import { PLATFORM } from 'aurelia-framework';
import { roles } from 'routes';

export const customer_routes = [
  {
    route: ['customers'],
    name: 'customer-list',
    settings: {
      roles: [
        roles.superService,
        roles.serviceuser,
        roles.pensAdministrator,
        roles.pensSales,
        roles.mooringAdministrator,
        roles.mooringSeller,
        roles.mooringcalculation,
        roles.sales,
        roles.production,
        roles.analysisEngineer,
      ],
      searchable: true,
    },
    viewPorts: {
      main: { moduleId: PLATFORM.moduleName('components/customer/customer-list') },
      side: { moduleId: null },
    },
    nav: true,
    title: 'general.customer_plural',
    route_base: 'customer',
    section: 'crm',
  },
  {
    route: ['customer/:Id'],
    name: 'customer-detail',
    settings: {
      roles: [
        roles.superService,
        roles.serviceuser,
        roles.pensAdministrator,
        roles.pensSales,
        roles.mooringAdministrator,
        roles.mooringSeller,
        roles.mooringcalculation,
        roles.sales,
        roles.production,
        roles.analysisEngineer,
      ],
    },
    viewPorts: {
      main: { moduleId: PLATFORM.moduleName('components/customer/customer-detail') },
      side: { moduleId: null },
    },
  },
  {
    route: ['customer/new'],
    name: 'customer-new',
    settings: {
      roles: [
        roles.superService,
        roles.serviceuser,
        roles.pensAdministrator,
        roles.pensSales,
        roles.mooringAdministrator,
        roles.mooringSeller,
        roles.mooringcalculation,
        roles.sales,
        roles.production,
        roles.analysisEngineer,
      ],
      searchable: true,
    },
    viewPorts: {
      main: { moduleId: PLATFORM.moduleName('components/customer/customer-new') },
      side: { moduleId: null },
    },
    title: 'customer.new',
  },
  {
    route: ['customer/:Id/merge'],
    name: 'customer-merge',
    settings: {
      roles: [
        roles.superService,
        roles.serviceuser,
        roles.pensAdministrator,
        roles.pensSales,
        roles.mooringAdministrator,
        roles.mooringSeller,
        roles.mooringcalculation,
        roles.sales,
        roles.production,
        roles.analysisEngineer,
      ],
      searchable: false,
    },
    viewPorts: {
      main: { moduleId: PLATFORM.moduleName('components/customer/customer-merge') },
      side: { moduleId: null },
    },
    title: 'customer.merge',
  },
  {
    route: ['customer/:Id/edit'],
    name: 'customer-edit',
    settings: {
      roles: [
        roles.superService,
        roles.serviceuser,
        roles.pensAdministrator,
        roles.pensSales,
        roles.mooringAdministrator,
        roles.mooringSeller,
        roles.mooringcalculation,
        roles.sales,
        roles.production,
        roles.analysisEngineer,
      ],
    },
    viewPorts: {
      main: { moduleId: PLATFORM.moduleName('components/customer/customer-edit') },
      side: { moduleId: null },
    },
  },
];
